__turbopack_context__.v({
  "firmRoleItem__pill": "FirmRoleItem-module__u7Xi0a__firmRoleItem__pill",
  "firmRoleItem__pillEditing": "FirmRoleItem-module__u7Xi0a__firmRoleItem__pillEditing",
  "firmRoleItem__text": "FirmRoleItem-module__u7Xi0a__firmRoleItem__text",
});
